import React from "react";
import { View, Text, Button, Icon } from "ui";

import { Player, BigPlayButton } from "video-react";
import "../../../node_modules/video-react/dist/video-react.css"; // import css

export default class Homepage extends React.Component {
  public state = {
    openModal: false
  };

  public handlePresentation = () => {
    this.setState({ openModal: true });
  }
  public handleClosePresentation = () => {
    setTimeout(() => {
      this.setState({ openModal: false });
    }, 10);
  }

  public render = () => {
    return (
      <View flexDirection="column" alignItems="flex-start" pl={3} pr={4}>

        <View mt={1} width="30rem">
          <Player
            playsInline
            poster="/assets/poster.png"
            src="/automemo_prezentare.mp4"
            autoPlay
            fluid
          >
            <BigPlayButton position="center" />
          </Player>
        </View>
        <View flexDirection="row" mt={2} mb={2}>
          <Icon name="check" size={1.5} color="#f16541" />
          <View flexWrap="wrap">
            <Text color="primary" fontWeight="bold" fontSize={3} ml={1} mr={1}>
              AutoMemo
            </Text>
            <Text color="black" fontSize={3}>
              iti reaminteste ce ai de platit si nu numai.
            </Text>
          </View>
        </View>
        <View flexDirection="row" mb={2}>
          <Icon name="check" size={1.5} color="#f16541" />
          <Text color="black" fontSize={3} ml={1}>
            Adauga TOATE VEHICULELE din parcul tau auto.
          </Text>
        </View>
        <View flexDirection="row" mb={2}>
          <Icon name="check" size={1.5} color="#f16541" />
          <Text color="black" fontSize={3} ml={1}>
            Selecteaza datele de expirare pentru RCA, ITP, ...
          </Text>
        </View>
        <View flexDirection="row" mb={2}>
          <Icon name="check" size={1.5} color="#f16541" />
          <Text color="black" fontSize={3} ml={1}>
            TE ALERTAM prin sms si email INAINTE ca acestea sa expire.
          </Text>
        </View>
        <View flexDirection="row" mb={2}>
          <Icon name="check" size={1.5} color="#f16541" />
          <Text color="black" fontSize={3} ml={1}>
            TESTEAZA &nbsp;
          </Text>
          <Text color="primary" fontSize={3}>
            60 de zile GRATUIT.
          </Text>
        </View>
      </View>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/public/Homepage.tsx